export const formatCRC = (value: number): string => {
  const monto = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(monto);
};
